/*
  record-link.js

  A local helper to record the
  continue later link in a given
  input field, so the model has
  access to it as well.

  Author: Tim Bauwens
  Copyright: xxllnc 2023
*/
import { bb } from "$json";
const pluginid = "session-link-for-pdf";

jQuery(document).on(
  "bb-p:control-filter",
  function (ev, control, group, index, grid, data) {
    if (control.metadata && control.metadata[pluginid]) {
      const location = bb.propFinder(bb.conf)(
        "arbitrary.savecase-email-link-popup.location",
        window.location.href
      );
      let continueLink = `${location}?modelid=${data.dbname}&sessionid=${data.sessionid}`;
      control.value = continueLink;
      control.controltype = "hidden";
    }
  }
);
